import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';

import Header from 'containers/PasswordRecoveryPages/Header';
import messages from 'containers/PasswordRecoveryPages/InsertNewPassword/messages';
import { translate } from 'helpers/intl';
import Form from 'containers/PasswordRecoveryPages/InsertNewPassword/Form';
import GaLoadHOC from 'helpers/GATracking/GaLoadHOC';
import { EVENT_CATEGORIES } from 'helpers/GATracking';

const InsertNewPassword = (props: {
  intl: IntlShape;
  isLoading: boolean;
  onSubmitStep: Function;
}) => (
  <GaLoadHOC
    category={EVENT_CATEGORIES.FORGOTTEN_NEW_PASSWORD}
    label="chargement de la page"
  >
    <>
      <Header
        title={translate({ ...messages.formTitle }, props)}
        subTitle={translate({ ...messages.formSubTitle }, props)}
      />
      <Form isLoading={props.isLoading} onSubmit={props.onSubmitStep} />
    </>
  </GaLoadHOC>
);

export default injectIntl(InsertNewPassword);
